<template>
<div>
  <el-table :data="syncData.list">
    <el-table-column type="index" :label="$t('zhiji.knowlege.imExHistoryModal.order')" width="80" />
    <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.syncScene')" width="300">
      <template slot-scope="scope">
        {{ getSecenPath(scope.row) }}
      </template>
    </el-table-column>
    <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.syncStatus')" width="360">
      <template slot-scope="scope">
        <span v-if="scope.row.task_status === 0">{{ $t('zhiji.knowlege.imExHistoryModal.waiting') }}</span>
        <span v-else-if="scope.row.task_status === 1">{{ $t('zhiji.knowlege.imExHistoryModal.syncing') }}</span>
        <span v-else-if="scope.row.task_status === 2">{{ getSyncCompleteSummary(scope.row) }}</span>
        <span v-else-if="scope.row.task_status === 3">{{ scope.row.task_error_info || $t('zhiji.knowlege.imExHistoryModal.syncFail') }}</span>
        <span v-else>{{ scope.row.state }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.syncEndTime')" width="300">
      <template slot-scope="scope">
        <div>
          <span v-if="scope.row.task_status === 0">{{ $t('zhiji.knowlege.imExHistoryModal.waiting') }}</span>
          <span v-else>{{ scope.row.end_time }}<span v-if="scope.row.task_status === 1">{{ $t('zhiji.knowlege.imExHistoryModal.estimatedTime') }}</span></span>
        </div>
      </template>
    </el-table-column>
    <el-table-column property="operator" :label="$t('zhiji.knowlege.imExHistoryModal.operator')" width="100" />
    <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.syncProgress')" width="200">
      <template slot-scope="scope">
        <div class="progress-cell">
          <span v-if="scope.row.task_status === 2">{{ $t('zhiji.knowlege.imExHistoryModal.syncCompleted') }}</span>
          <el-progress v-else :percentage="getProgressPercent(scope.row)" :show-text="true" />
        </div>
      </template>
    </el-table-column>
  </el-table>
  <FooterPage
    :size="syncData.size"
    :total="syncData.total"
    :page="syncData.page"
    @sizeChange="sizeChange"
    @pageChange="pageChange"
  />
</div>
</template>

<script>
import FooterPage from '@/views/zhiji/components/foot-page.vue'

export default {
  name: 'SyncStatus',
  components: {
    FooterPage
  },
  props: {
    status: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      syncData: {
        list: [],
        page: 1,
        size: 10,
        total: 1,
      },
      language: '',
      pollingTimer: null,
    };
  },
  watch: {
    status (modelStatus) {
      // eslint-disable-next-line no-unused-expressions
      modelStatus && this.startPolling();
    },
    "$i18n.locale": {
      handler(value) {
        this.language = value;
      },
      immediate: true
    },
  },
  mounted () {
    this.startPolling();
  },
  beforeDestroy () {
    this.stopPolling();
  },
  methods: {
    async getSyncData () {
      try {
        const { list, count } = await this.zhiji.requestByServiceName("getFaqSyncList",{
          page: this.syncData.page,
          size: this.syncData.size,
        });
        this.syncData.list = list || [];
        this.syncData.total = count || 0;
        // 有未完成任务（等待中/进行中）时继续轮询，否则停止
        const hasUnfinished = (list || []).some(item => item.task_status === 0 || item.task_status === 1);
        if (!hasUnfinished) {
          this.stopPolling();
        }
      } catch (e) {
        this.syncData.list = [];
        this.syncData.total = 0;
        this.stopPolling();
      }
    },
    startPolling () {
      this.stopPolling();
      this.getSyncData();
      this.pollingTimer = setInterval(() => {
        this.getSyncData();
      }, 5000);
    },
    stopPolling () {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    sizeChange (newSize) {
      this.syncData.size = newSize;
      this.syncData.page = 1;
      this.getSyncData();
    },
    pageChange (newPage) {
      this.syncData.page = newPage;
      this.getSyncData();
    },
    getSecenPath (row) {
      if (row.sync_type === 0) {
        return this.$i18n.t('zhiji.knowlege.imExHistoryModal.syncAll')
      };
      return this.$i18n.t('zhiji.knowlege.imExHistoryModal.syncByCategory');
    },
    getProgressPercent (row) {
      const res = parseFloat(row.schedule_percentage);
      return isNaN(res) ? 0 : res;
    },
    getSyncCompleteSummary (row) {
      return this.$t('zhiji.knowlege.imExHistoryModal.syncCompleteSummary', {
        0: this.formatNum(row.synced_num),
        1: this.formatNum(row.synced_ext_num),
        2: this.formatNum(row.synced_answer_num)
      });
    },
    formatNum (num) {
      if (num == null) {
        return '0'
      };
      return String(num);
    },
  },
};
</script>

<style lang="less" scoped>
.progress-cell {
  padding: 4px 0;
}
</style>
